<div><span class="document-source">{{sourceToLabel(source)}}</span></div>
